import request from "@/utils/request";


// 查询好评top榜内容
export function getTopListDetail() {
  return request({
    url: '/product/top-goods/h5/queryTopContent',
    method: 'get',
  })
}


// 查询好评top榜列表
export function getTopList() {
  return request({
    url: '/product/top-goods/h5/queryTopTheme',
    method: 'get',
  })
}
